import styled from "styled-components";

export const StyledThContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    white-space: nowrap;
    align-items: center;
`;